<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Manage versions</span>
        </v-card-title>
        <v-card-text class="mt-n5">
          <v-container>
            <v-row>
              <v-col cols="10">
                <v-file-input
                  show-size
                  label="Upload Document"
                  v-model="file"
                ></v-file-input>
                <p class="mt-n4 mb-n2 ml-8 red--text" v-if="no_file_error">
                  <v-icon class="red--text">mdi-alert-outline</v-icon>
                  upload new version
                </p>
              </v-col>
              <v-col cols="2">
                <v-btn
                  small
                  color="indigo"
                  dark
                  class="mt-5"
                  @click="uploadDocument()"
                  v-if="!isUploaded"
                >
                  Upload
                </v-btn>
                <v-chip class="mt-4" color="green" text-color="white" v-else>
                  <v-icon>mdi-check</v-icon>
                </v-chip>
              </v-col>
            </v-row>
            <v-row class="mt-n4">
              <v-col cols="12">
                <p>
                  Version History
                    <v-progress-circular
                      indeterminate
                      color="indigo"
                      class="ml-2"
                      :size="20"
                      v-show="historyLoadingStatus && documentHistory.length < 1"
                    ></v-progress-circular>
                </p>
              </v-col>
              <v-col cols="12" style="height: 300px; overflow-y: auto;">
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Uploaded by
                        </th>
                        <th class="text-left">
                          Date Uploaded
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="document in documentHistory"
                        :key="document.id"
                      >
                        <td>{{ "Steven Damayo Fixed" }}</td>
                        <td>{{ document.date_uploaded }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2";
import { fileSystemUrl } from '../../config/config.json';

export default {
  name: "UploadDocumentVersionDialog",
  props: {
    dialog: Boolean,
    routeId: Number,
    routeType: String,
    documentId: Number,
    transactionId: String,
    document: Object,
    subRouteIndex: Number,
    parentRouteId: String,
  },
  data() {
    return {
      file: null,
      no_file_error: false,
      isUploaded: false,
      filepath_url: null,
      date_uploaded: null,
      historyLoadingStatus: true
    };
  },
  methods: {
    ...mapActions([
      "uploadNewDocumentVersion",
      "routeUpdateDocumentVersion",
      "subRouteUpdateDocumentVersion",
      "fetchDocumentVersionHistory",
      "clearDocumentHistory"
    ]),
    close() {
      this.file = null;
      this.no_file_error = false;
      this.filepath_url = null;
      this.date_uploaded = null;
      this.$emit("closeDialog", false);
    },
    async uploadDocument() {
      this.upload_loader = false;
      this.no_file_error = false;

      if (this.file) {
        this.upload_loader = true;
        const formData = new FormData();

        formData.append("documentFile", this.file, this.file.name);

        try {
          const authToken = localStorage.getItem("access_token");
          const response = await axios.post(`${fileSystemUrl}/uploadFile`, formData, {
            headers: {
              "x-drmms-token": authToken,
              "Content-Type": "multipart/form-data",
            },
          });

          this.filepath_url = response.data.filepath_url;
          this.date_uploaded = response.data.date_uploaded;
          this.user_uploaded = response.data.user_id;
          this.upload_loader = false;
          this.disable_upload = true;
          this.isUploaded = true;

          let body = {
            filepath_url: this.filepath_url,
            date_uploaded: this.date_uploaded,
            user_uploaded: this.user_uploaded,
            document_id: this.document.document_id,
            document_instance_id: this.document.document_instance_id,
            route_id: this.routeId,
            type: this.routeType,
            transaction_id: this.transactionId,
            isMainDocument: this.transactionId == "na" ? false : true,
          };

          let result;

          if (!this.routeId) {
            this.uploadNewDocumentVersion(body).then(() => {
              Swal.fire({
                icon: "success",
                title: "New document version uploaded",
                showConfirmButton: false,
                timer: 1500,
              });
            });
          } else {
            if (this.routeType != "subroute") {
              result = await this.routeUpdateDocumentVersion(body);
            } else {
              body = Object.assign(body, {
                route_index: this.subRouteIndex,
                container: this.parentRouteId,
              });
              result = await this.subRouteUpdateDocumentVersion(body);
            }

            if (result) {
              Swal.fire({
                icon: "success",
                title: "New document version uploaded",
                showConfirmButton: false,
                timer: 1500,
              }).then(() => {
                this.close();
              });
            }
          }
        } catch (err) {
          console.log(err);
        }
      } else {
        this.no_file_error = true;
      }
    },
  },
  computed: mapGetters(['documentHistory']),
  watch: {
    dialog() {
      if(this.dialog) {
        this.fetchDocumentVersionHistory(this.documentId)
          .then(() => this.historyLoadingStatus = false);
      }
    }
  },
  beforeDestroy() {
    this.clearDocumentHistory()
  }
};
</script>

<style></style>
